import React from "react";
import { BadgeCheck } from "lucide-react";

export const SCREEN_PROBLEM = "Knust skjerm";
export const BATTERY_PROBLEM = "Dårlig batteri";

export default function PartsQualityInfo({ showScreens = true, showBatteries = true, testid = "parts-quality-info" }) {
  if (!showScreens && !showBatteries) return null;
  return (
    <div className="rounded-xl border border-electric/20 bg-electric/5 p-4 text-sm text-navy" data-testid={testid}>
      <h4 className="flex items-center gap-2 font-heading text-base font-bold text-navy">
        <BadgeCheck className="h-4 w-4 shrink-0 text-electric" /> Kvalitet på reservedeler
      </h4>
      <div className="mt-2.5 space-y-2 text-ink/75 leading-relaxed">
        {showScreens && (
          <p data-testid={`${testid}-screens`}>
            <strong className="font-semibold text-navy">Skjermer:</strong> Prisene gjelder Soft OLED-skjermer av høy kvalitet.
            Modeller som opprinnelig har 120 Hz ProMotion, beholder støtte for 120 Hz. Andre modeller fungerer med sin
            opprinnelige oppdateringsfrekvens.
          </p>
        )}
        {showBatteries && (
          <p data-testid={`${testid}-batteries`}>
            <strong className="font-semibold text-navy">Batterier:</strong> På iPhone 12-serien til og med iPhone 15 Pro Max bruker
            vi kvalitetsbatterier med systemtilpasning. Batteritilstand vises normalt i innstillingene, og telefonen viser ikke
            varsel om ukjent del.
          </p>
        )}
      </div>
    </div>
  );
}
